// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"c673f324","403":"b8f62e78","740":"6d9bd6c3"}[chunkId] + ".chunk.js";
};